var arabam;
(function (arabam) {
    var breadcrumbFavoriteController = /** @class */ (function () {
        function breadcrumbFavoriteController(HttpHelperService, $rootScope) {
            var _this = this;
            this.HttpHelperService = HttpHelperService;
            this.$rootScope = $rootScope;
            this.popupEl = null;
            this.toggleButton = null;
            this.isPopupVisible = false;
            this.favoriteList = null;
            this.isUserLoggedIn = window.arabamUser.IsUserLoggedIn;
            this.favoriteSearchLoading = false;
            this.init = function () {
                _this.popupEl = document.getElementById("favoritePopup");
                _this.toggleButton = document.getElementById("favSearchButton");
                // console.log("rootScope:", this.$rootScope);
                _this.getMember();
            };
            this.getMember = function () {
                var self = _this;
                self.HttpHelperService.httpGet("/home/memberInfo?random=" + new Date().getTime(), function (response) {
                    // console.log("memberInfo", response);
                    if (response.Data) {
                        _this.isUserLoggedIn = true;
                        _this.$rootScope.$on("favoriteSearchListUpdated", function () {
                            // console.log("favSearch list updated");
                            //this.fetchFavoriteSearches();
                        });
                        //this.fetchFavoriteSearches();
                    }
                });
            };
            this.onClickOutside = function (event) {
                var target = event.target;
                if (event.target != _this.toggleButton) {
                    if (!_this.popupEl.contains(target))
                        _this.hidePopup();
                }
            };
            this.init();
        }
        breadcrumbFavoriteController.prototype.togglePopup = function (event) {
            // event.stopPropagation();
            // console.log("togglePopup");
            // event.preventDefault();
            if (!this.isUserLoggedIn) {
                window.location.href = "/uyelik?returnUrl=" + window.location.pathname;
            }
            else if (this.isPopupVisible) {
                this.hidePopup();
            }
            else {
                this.showPopup();
            }
        };
        breadcrumbFavoriteController.prototype.showPopup = function () {
            // console.log("show");
            document.addEventListener("click", this.onClickOutside, false);
            this.popupEl.classList.add("show");
            this.isPopupVisible = true;
            this.fetchFavoriteSearches();
        };
        breadcrumbFavoriteController.prototype.hidePopup = function () {
            // console.log("hide");
            document.removeEventListener("click", this.onClickOutside, false);
            this.popupEl.classList.remove("show");
            this.isPopupVisible = false;
        };
        breadcrumbFavoriteController.prototype.showPopupForAWhile = function () {
            var _this = this;
            if (this.popupTimeout) {
                clearTimeout(this.popupTimeout);
            }
            this.showPopup();
            this.popupTimeout = setTimeout(function () {
                _this.hidePopup();
            }, 1500);
        };
        breadcrumbFavoriteController.prototype.fetchFavoriteSearches = function () {
            var _this = this;
            var params = { Page: 1, Take: 40 };
            this.favoriteSearchLoading = true;
            this.HttpHelperService.httpPost("/favorite/searchs", params, function (response) {
                // console.log("fav data:", data);
                _this.favoriteSearchLoading = false;
                _this.favoriteList = response.Data.Documents.map(function (item) {
                    return {
                        name: item.Name,
                        url: item.Url
                    };
                });
                // console.log("favoriteList", this.favoriteList);
            }, null, { isNotLoading: true });
        };
        breadcrumbFavoriteController.$inject = ["HttpHelperService", "$rootScope"];
        return breadcrumbFavoriteController;
    }());
    angular.module("arabam").controller("breadcrumbFavoriteController", breadcrumbFavoriteController);
})(arabam || (arabam = {}));
